import { createSelector } from "reselect"
import { get, first, chain } from "lodash"
import { getStartDate, getEndDate } from "modules/security-profile/selectors/dates"

const defaultBetaData = {}
const getBetaData = state => get(state, "global.data.securityBetaHistory.data.model.simulation.beta", defaultBetaData)

function formatBeta(beta) {
  return chain(beta)
    .map(({ date, predicted, historical }) => {
      return ({
        date,
        factors: {
          predicted,
          historical,
        },
      })
    })
    .filter(data => data)
    .value()
}

export const getBeta = createSelector(
  [getBetaData],
  (absolute) =>
    formatBeta(absolute),
)

export const getFilteredBeta = createSelector(
  [getBeta, getStartDate, getEndDate],
  (beta, startDate, endDate) => {
    return beta.filter((data) => {
      if (data.date >= startDate && data.date <= endDate) {
        return data
      } else {
        return null
      }
    })
  },
)

export const getFirst = createSelector(
  [getBeta],
  (beta) => first(beta),
)

export const getFirstHistoricalBetaDate = createSelector(
  [getFilteredBeta],
  (beta) => get(first(beta), "date", null),
)
